import { setupInfiniteScroll, setupGenericSearch } from "../../utils/common.js";
import { initDiscountsModule } from "./discounts.js";
import "../shared/nf-manager.js";
import "./form-manager.js";
import { initServiceOrderFilters } from "./filter.js";

let paginationInstance = null;

$(document).ready(function () {
    // Initialize discounts module
    initDiscountsModule();

    // Initialize filters only on orders index page
    if ($("body").hasClass("orders-index")) {
        initServiceOrderFilters();
    }

    // Helper function to get filter parameters
    const getFilterParams = function () {
        return {
            status: $("#filtersStatus").val() || "todos",
            emissao_de: $("#emissaoDe").val(),
            emissao_ate: $("#emissaoAte").val(),
            conclusao_de: $("#conclusaoDe").val(),
            conclusao_ate: $("#conclusaoAte").val(),
            status_os: $("#statusOS").val(),
            status_pagamento: $("#statusPagamento").val(),
            responsavel: $("#responsavelSelect").val(),
            cliente: $("#clienteSelect").val(),
            veiculo: $("#veiculoSelect").val(),
            order_by: $("#orderBySelect").val() || "id_os",
        };
    };

    // Initialize service orders list with infinite scroll
    if ($(".tbodyAll").length) {
        paginationInstance = setupInfiniteScroll(
            ".tbodyAll",
            "/OS",
            "#currentPage",
            {
                getParams: function () {
                    // Garante que os parâmetros de filtro sejam capturados no momento do scroll
                    return getFilterParams();
                },
            },
        );
    }

    // Initialize search functionality
    if ($("#searchServiceOrders").length) {
        setupGenericSearch(
            "#searchServiceOrders",
            "/OS/search",
            "#serviceOrdersList",
            ".tbodyAll",
            getFilterParams,
        );
    }

    // Trigger search when order by changes
    $("#orderBySelect").on("change", function () {
        $(document).trigger("search:refresh");
    });

    // Order By via dropdown options
    $(document).on("click", ".js-sort-option", function (e) {
        e.preventDefault();

        $(".js-sort-option").removeClass("active");
        $(this).addClass("active");

        const value = $(this).data("value");
        $("#orderBySelect").val(value).trigger("change");
    });

    // Handle service order status changes
    $(".service-order-status").on("change", function () {
        const orderId = $(this).data("order-id");
        const newStatus = $(this).val();
        updateServiceOrderStatus(orderId, newStatus);
    });

    // Handle service order form submission
    $("#serviceOrderForm").on("submit", function (e) {
        e.preventDefault();
        handleServiceOrderSubmission(this);
    });

    // Handle add service item
    $("#addServiceItem").on("click", function () {
        addServiceItem();
    });

    // Handle remove service item
    $(document).on("click", ".remove-service-item", function () {
        removeServiceItem(this);
    });

    // Handle service order print
    $(document).on("click", ".js-print-order", function (e) {
        e.preventDefault();
        const url = $(this).attr("href");
        window.open(url, "_blank");
    });

    // Exportar Excel (CSV)
    $(document).off("click.exportCsv", "#exportCsv");
    $(document).on("click.exportCsv", "#exportCsv", function (e) {
        e.preventDefault();

        // 1. Check for selected IDs
        const ids = $(".table-all-tab .tbodyAll .order-select:checked")
            .map(function () {
                return $(this).data("id");
            })
            .get();

        if (ids.length === 0) {
            const message = "Selecione pelo menos uma ordem de serviço.";

            // Prioriza o modal padrão de erro com ícone (Bootstrap)
            if (
                window.bootstrap &&
                typeof window.bootstrap.Modal !== "undefined"
            ) {
                let modalEl = document.getElementById("errorModal");
                if (!modalEl) {
                    modalEl = document.createElement("div");
                    modalEl.id = "errorModal";
                    modalEl.className = "modal fade";
                    modalEl.setAttribute("tabindex", "-1");
                    modalEl.setAttribute("aria-modal", "true");
                    modalEl.setAttribute("role", "dialog");
                    modalEl.innerHTML = `
                        <div class="modal-dialog modal-dialog-centered">
                            <div class="modal-content">
                                <div class="modal-body text-center">
                                    <span class="icon-bg-lg m-auto mb-3"><i class="sg sg-smiley-x-eyes"></i></span>
                                    <div id="errorModalMessages" class="mb-3"></div>
                                    <div class="text-center d-flex justify-content-center">
                                        <button type="button" class="btn btn-primary" data-bs-dismiss="modal">Fechar</button>
                                    </div>
                                </div>
                            </div>
                        </div>`;
                    document.body.appendChild(modalEl);
                }

                const messagesEl = modalEl.querySelector("#errorModalMessages");
                if (messagesEl) {
                    messagesEl.innerHTML = `<p class="mb-0">${message}</p>`;
                }

                const modal = new window.bootstrap.Modal(modalEl, {
                    backdrop: "static",
                    keyboard: false,
                });
                modal.show();
                return;
            }

            // Fallback
            alert(message);
            return;
        }

        // Export Selected
        const url = `/OS/export/csv?selected_ids=${encodeURIComponent(
            ids.join(",")
        )}`;
        window.location.href = url;
    });

    $(".print-service-order").on("click", function () {
        const orderId = $(this).data("order-id");
        printServiceOrder(orderId);
    });

    // Calculate totals when items change
    $(document).on(
        "input",
        ".service-item-qty, .service-item-price",
        function () {
            calculaTotais();
        },
    );

    // Update pagination when search completes
    $(document).on("search:success", function (e, response, data) {
        if (paginationInstance) {
            paginationInstance.page = 2;

            const hasFilters =
                data.value ||
                data.emissao_de ||
                data.status_os ||
                data.status_pagamento ||
                data.responsavel ||
                (data.cliente && data.cliente.length > 0) ||
                (data.veiculo && data.veiculo.length > 0);

            if (hasFilters) {
                paginationInstance.config.loadUrl = "/OS/search";
                paginationInstance.config.extraParams = data;
            } else {
                paginationInstance.config.loadUrl = "/OS";
                paginationInstance.config.extraParams = {};
            }

            paginationInstance.loading = false;
        }
    });

    // Mobile "Selecionar todos" toggle
    $(document).on("click", "#btnSelectAll", function () {
        const checkbox = $("#selectAllVisible");
        checkbox.prop("checked", !checkbox.is(":checked")).trigger("change");
    });
});
